module.exports = __webpack_public_path__ + "media/images/plans/img_online4-7c392bd56b72ec3615f9a74f2e794aa2.jpg";